import Cesium from 'cesium';

import Logging from '~app/core/logging';

const log = Logging.getLogger('app.core.createProjectedText');

export function createProjectedText(location, image, size, align, applyGlobeProjection) {
  return new Cesium.Entity({
    rectangle: {
      coordinates: rectangleForImage(size, location, align, 0.1, applyGlobeProjection),
      material: new Cesium.ImageMaterialProperty({
        image,
        transparent: true,
      }),
    },
  });
}

function rectangleForImage(size, location, align, pixelToEquatorialDegreeRatio, applyGlobeProjection) {
  const [lon, lat] = location.coordinates();

  // Compute the image dimensions in radians given the pixel-to-angle ratio.
  let imageLon = size.width  * pixelToEquatorialDegreeRatio * (Math.PI / 180.0);
  let imageLat = size.height * pixelToEquatorialDegreeRatio * (Math.PI / 180.0);

  if (applyGlobeProjection) {
    // The earth radius is involved in this computation, but would cancel out
    // in the final division.
    imageLon /= (Math.cos(lat));
  }

  // Shift by 1/3 degree to pad the text away from its grid line.
  const alignPadding = 0.33 * (Math.PI / 180.0);

  let east = lon;
  let west = lon;
  if (align.horizontal === 'left') {
    west += alignPadding;
    east = west + imageLon;
  }
  else if (align.horizontal === 'center') {
    east += imageLon / 2.0;
    west -= imageLon / 2.0;
  }
  else if (align.horizontal === 'right') {
    east -= alignPadding;
    west = east - imageLon;
  }
  else {
    log.error(`Unexpected horizontal alignment value: ${align.vertical}`);
  }

  let north = lat;
  let south = lat;
  if (align.vertical === 'top') {
    north -= alignPadding;
    south = north - imageLat;
  }
  else if (align.vertical === 'center') {
    north += imageLat / 2.0;
    south -= imageLat / 2.0;
  }
  else if (align.vertical === 'bottom') {
    south += alignPadding;
    north = south + imageLat;
  }
  else {
    log.error(`Unexpected vertical alignment value: ${align.vertical}`);
  }

  return Cesium.Rectangle.fromRadians(
    clampLon(west),
    clampLat(south),
    clampLon(east),
    clampLat(north)
  );
}

function clampLat(lat) {
  return clamp(lat, -Math.PI / 2.0, Math.PI / 2.0);
}

function clampLon(lon) {
  return clamp(lon, -Math.PI, Math.PI);
}

function clamp(val, min, max) {
  const range = (max - min);
  while (val < min) {
    val += range;
  }
  while (val > max) {
    val -= range;
  }
  return val;
}

export default createProjectedText;



// WEBPACK FOOTER //
// ./src/core/createProjectedText.js